<template>
  <div class="update-screen-state-message">
    <Flex
      class="update-screen-state-message-content"
      flex-direction="column"
      row-gap="0.75rem"
      align-items="center"
    >
      <FlexItem>
        <BigAppLogo dark width="250" height="280" />
      </FlexItem>

      <FlexItem class="update-screen-state-message-title">
        Updating to the Latest Version
      </FlexItem>

      <FlexItem class="update-screen-state-message-description">
        You’re being upgraded to the latest version of the platform. This will only take a
        moment.
      </FlexItem>
    </Flex>
  </div>
</template>

<style lang="scss" scoped>
// Styles removed - not needed in lite edition
</style>
